import React from "react";
import { TransactionStatusTag } from "../../components/common/registerUtils";
import {
  beautify,
  formatDateTime,
  NoWrap,
  createViewAction,
} from "../../utils/helpers";
import { FormActions } from "../../components/common/FormActions";
import { URL_SECURITY_ACTIVITY } from "../../utils/urls";

const url = URL_SECURITY_ACTIVITY;

export const useSecurityAudit = () => {
  const tableColumns = () => [
    { id: "timestamp", header: "Time", filter: { type: "date" } },
    { id: "user", header: "User", filter: { type: "text" } },
    {
      id: "event_type_display",
      header: "Event",
      filter: { type: "text" },
    },
    { id: "status", header: "Status", filter: { type: "select" } },
    { id: "identifier", header: "Identifier", filter: { type: "text" } },
    { id: "ip_address", header: "IP Address", filter: { type: "text" } },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any[]) =>
    data?.map((item: any) => ({
      ...item,
      timestamp: <NoWrap>{formatDateTime(item?.timestamp)}</NoWrap>,
      user: item?.user_phone_number || item?.user_email || "—",
      event_type_display: beautify(
        item?.event_type_display || item?.event_type,
      ),
      status: <TransactionStatusTag status={item?.status} />,
      actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
    })) ?? [];

  const viewData = (item: any) => ({
    sections: [
      {
        title: "Event Details",
        fields: {
          "Event Type": beautify(item?.event_type_display || item?.event_type),
          Status: <TransactionStatusTag status={item?.status} />,
          Timestamp: formatDateTime(item?.timestamp),
          Identifier: item?.identifier || "—",
          "IP Address": item?.ip_address || "—",
        },
      },
      {
        title: "User Details",
        fields: {
          "Actor Name": item?.actor_name || "—",
          "Phone Number": item?.user_phone_number || "—",
          Email: item?.user_email || "—",
          "User ID": item?.user_id || "—",
        },
      },
    ],
  });

  return { tableColumns, tableData, viewData };
};
